var _path, _circle, _g, _circle2, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_3534)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 57L45 91L36 73L85 39L94 57Z",
    fill: "#818CF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_3534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 35,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 65,
    r: 30,
    transform: "rotate(-180 100 65)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_3534)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 65,
    r: 20,
    transform: "rotate(-180 100 65)",
    stroke: "#EEF2FF",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 62.9992C110 44.393 104.603 29.1902 95.6493 18.5579C92.0919 14.3334 82.7834 13.7927 78.5589 17.3501C74.3344 20.9076 73.7936 27.2161 77.3511 31.4406C84.3976 39.8083 90.0002 50.6055 90.0002 62.9992H90.2C91.1264 58.4347 95.162 54.999 100 54.999C104.838 54.999 108.874 58.4347 109.8 62.9992H110Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.815 56.2336C103.538 39.7896 95.8256 26.2682 87.6491 16.5586C84.0917 12.3342 77.7832 11.7934 73.5587 15.3509C69.3342 18.9083 68.7935 25.2169 72.3509 29.4414C79.3974 37.8091 85 48.6062 85 61L90.8321 61C92.3752 57.4682 95.8994 55 100 55C101.746 55 103.387 55.4473 104.815 56.2336Z",
    fill: "#C7D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.48 55.0133C97.5175 40.0198 90.2857 27.6268 82.6493 18.5586C79.0919 14.3342 72.7833 13.7934 68.5588 17.3509C64.3344 20.9083 63.7936 27.2169 67.3511 31.4414C74.3976 39.8091 80.0002 50.6062 80.0002 63L90.2002 63C91.0934 58.6001 94.8752 55.2493 99.48 55.0133Z",
    fill: "#A5B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4365 56.6893C91.761 58.4839 90 61.5363 90 65L75 65C75 52.6062 69.3974 41.8091 62.3509 33.4414C58.7935 29.2169 59.3342 22.9083 63.5587 19.3509C67.7832 15.7934 74.0917 16.3342 77.6491 20.5586C85.2304 29.5614 92.413 41.8412 94.4365 56.6893Z",
    fill: "#818CF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_117_3534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 35,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 65,
    r: 30,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_117_3534)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 65,
    r: 20,
    stroke: "#EEF2FF",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 67.0008C19.9998 85.607 25.3972 100.81 34.3507 111.442C37.9081 115.667 47.2166 116.207 51.4411 112.65C55.6656 109.092 56.2064 102.784 52.6489 98.5594C45.6024 90.1917 39.9998 79.3945 39.9998 67.0008L39.8 67.0008C38.8736 71.5653 34.838 75.001 30 75.001C25.162 75.001 21.1264 71.5653 20.2 67.0008L19.9998 67.0008Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1846 73.7664C26.4616 90.2104 34.1744 103.732 42.3509 113.441C45.9083 117.666 52.2168 118.207 56.4413 114.649C60.6658 111.092 61.2065 104.783 57.6491 100.559C50.6026 92.1909 45 81.3938 45 69H39.1679C37.6248 72.5318 34.1006 75 30 75C28.2542 75 26.613 74.5527 25.1846 73.7664Z",
    fill: "#C7D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.52 74.9867C32.4825 89.9802 39.7143 102.373 47.3507 111.441C50.9082 115.666 57.2167 116.207 61.4412 112.649C65.6657 109.092 66.2064 102.783 62.6489 98.5586C55.6024 90.1909 49.9998 79.3938 49.9998 67H39.7998C38.9066 71.3999 35.1248 74.7507 30.52 74.9867Z",
    fill: "#A5B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5635 73.3107C38.239 71.5161 40 68.4637 40 65H55C55 77.3938 60.6026 88.1909 67.6491 96.5586C71.2065 100.783 70.6658 107.092 66.4413 110.649C62.2168 114.207 55.9083 113.666 52.3509 109.441C44.7696 100.439 37.587 88.1588 35.5635 73.3107Z",
    fill: "#818CF8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3509 109.441C48.3974 98.8091 40 83.6062 40 65H60C60 77.3938 65.6026 88.1909 72.6491 96.5586C76.2066 100.783 75.6658 107.092 71.4414 110.649C67.2169 114.207 60.9084 113.666 57.3509 109.441Z",
    fill: "#EEF2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6491 20.5586C81.6026 31.1909 90 46.3938 90 65L70 65C70 52.6062 64.3974 41.8091 57.3509 33.4414C53.7934 29.2169 54.3342 22.9084 58.5586 19.3509C62.7831 15.7934 69.0916 16.3342 72.6491 20.5586Z",
    fill: "#EEF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_3534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 96,
    fill: "white",
    transform: "translate(0 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoIconWhite);
export default __webpack_public_path__ + "static/media/new-logo-icon-white.0375110d7db145e191e428e61a1af2b5.svg";
export { ForwardRef as ReactComponent };